export default __webpack_public_path__ + "static/media/apple-store-vi.33d7d302.svg";